/**
 * Italian localization for react-pivot. Keys mirror the original
 * auraPivot localization.json so slice configurations and existing
 * customizations keep working without translation changes.
 *
 * The PivotProvider merges this default with any `global.localization`
 * object passed in via props.
 */

const it = {
  fieldsList: {
    hierarchyBox: 'Trascina dimensioni',
    filterBox: 'Rilascia e ordina filtri report',
    rowBox: 'Rilascia e ordina righe',
    columnBox: 'Rilascia e ordina colonne',
    measureBox: 'Rilascia e ordina valori',
    values: 'Valori',
    expandAll: 'Espandi tutto',
    collapseAll: 'Comprimi tutto',
    allFields: 'Tutti i campi',
    rows: 'Righe',
    columns: 'Colonne',
    filters: 'Filtri',
    dropField: 'Rilascia campo qui',
    title: 'Campi',
    subtitle: 'Trascina i campi per riordinarli',
    addCalculated: 'Aggiungi valore calcolato',
    measuresAxisTooltip:
      'Campo speciale aggregazioni — trascinalo in Righe o Colonne per scegliere l’asse dei valori',
    calculatedFieldTooltip: 'Campo calcolato',
    showTotals: 'Mostra totali',
    perRow: 'Per riga',
    perColumn: 'Per colonna',
    dateFormat: 'Formato data',
    dateFormatHelp: 'Token: yyyy yy MMMM MMM MM M dd d EEEE EEE HH H mm m ss s',
    dateFormats: {
      localeDate: 'Locale browser (data)',
      localeDateTime: 'Locale browser (data e ora)',
      iso: 'ISO (yyyy-MM-dd HH:mm:ss)',
      isoDate: 'Data ISO (yyyy-MM-dd)',
      custom: 'Pattern personalizzato…',
    },
    subpartFormats: {
      month: {
        'name-full': 'Nome esteso (Gennaio)',
        'name-short': 'Nome breve (Gen)',
        number: 'Numero (1)',
        'number-padded': 'Numero con zero (01)',
      },
      quarter: {
        long: 'Esteso (Trimestre 1)',
        short: 'Breve (T1)',
        number: 'Numero (1)',
      },
      weekday: {
        'name-full': 'Nome esteso (Lunedì)',
        'name-short': 'Nome breve (Lun)',
      },
      week: {
        number: 'Numero (1)',
        long: 'Esteso (Settimana 1)',
      },
    },
  },
  grid: {
    total: 'Totale',
    grandTotal: 'Totale complessivo',
    blankMember: '(vuoto)',
    loading: 'Elaborazione in corso…',
    empty: 'Nessun dato da visualizzare',
    expandCollapseAll: 'Espandi/Comprimi tutto',
    expandCollapseChildren: 'Espandi / Comprimi livello successivo',
    grandTotalMeasureCaptionTemplate: 'Totale di {field} ({agg})',
    measureCaptionTemplate: '{field} ({agg})',
    hiddenMeasures: 'Altri valori',
    formulaError: 'Errore nella formula',
    sortAsc: 'Crescente',
    sortDesc: 'Decrescente',
    sortByMeasure: 'Ordina per valore',
    removeSort: 'Rimuovi ordinamento',
  },
  aggregations: {
    sum: 'Somma',
    count: 'Conteggio',
    distinctcount: 'Conteggio distinti',
    average: 'Media',
    min: 'Minimo',
    max: 'Massimo',
    ratioTotal: 'Rapporto sul totale',
    currentRatio: 'Incidenza',
  },
  buttons: {
    ok: 'OK',
    apply: 'Applica',
    cancel: 'Annulla',
    save: 'Salva',
    reset: 'Ripristina',
    close: 'Chiudi',
    edit: 'Modifica',
    delete: 'Elimina',
    saveChanges: 'Salva modifiche',
    create: 'Crea campo',
    removeFilter: 'Rimuovi filtro',
  },
  toolbar: {
    fields: 'Campi',
    format: 'Formato',
    export: 'Esporta',
    exportExcel: 'Esporta in Excel',
    fullscreen: 'Schermo intero',
    exitFullscreen: 'Esci da schermo intero',
  },
  filterBar: {
    title: 'Filtri',
    all: 'Tutti',
    values: 'valori',
  },
  filterEditor: {
    modeSingle: 'Valore singolo',
    modeSingleDate: 'Data singola',
    modeMulti: 'Valori multipli',
    modeRange: 'Intervallo',
    rangeFrom: 'Da',
    rangeTo: 'A',
    value: 'Valore',
    date: 'Data',
    search: 'Cerca…',
    selectAll: 'Seleziona tutto',
    noValues: 'Nessun valore.',
  },
  dimensionFilter: {
    subtitle: 'Seleziona i valori da includere nella pivot.',
    search: 'Cerca…',
    selectAll: 'Seleziona tutto',
    noValues: 'Nessun valore.',
    sortBy: 'Ordina per',
    columnSortNotice:
      'È attivo un ordinamento di colonna che ha la precedenza su questo ordinamento.',
    rowSortNotice:
      'È attivo un ordinamento di riga che ha la precedenza su questo ordinamento.',
  },
  drillThrough: {
    title: 'Dettaglio dati',
    record: 'record',
    recordsFound: 'record trovati',
    noRecords: 'Nessun record.',
  },
  calculatedField: {
    groupArithmetic: 'Aritmetica',
    groupComparison: 'Confronto / Logica',
    groupFunctions: 'Funzioni',
    groupAggregations: 'Aggregazioni e Progressivi',
    groupConstants: 'Costanti',
    tooltipIF: 'IF(condizione, valore_se_vero, valore_se_falso)',
    tooltipABS: 'Valore assoluto',
    tooltipMIN: 'Minimo di due o più numeri',
    tooltipMAX: 'Massimo di due o più numeri',
    tooltipSUM: 'Somma di un campo',
    tooltipCOUNT: 'Conteggio record',
    tooltipAVG: 'Media di un campo',
    tooltipMINField: 'Minimo del campo',
    tooltipMAXField: 'Massimo del campo',
    tooltipRunningSum:
      'Somma progressiva (cumulativa) del campo sulle righe visibili',
    invalidFormula: 'Formula non valida',
    errorNameRequired: 'Il nome del campo è obbligatorio.',
    errorFormulaRequired: 'La formula è obbligatoria.',
    editTitle: 'Modifica campo calcolato',
    createTitle: 'Aggiungi campo calcolato',
    nameLabel: 'Nome campo',
    formulaLabel: 'Formula',
    formulaPlaceholder: 'Esempio: sum("revenue") / count("orders") * 100',
    availableFields:
      'Campi numerici disponibili — clicca per inserire nella formula',
  },
  formatDialog: {
    subtitle:
      'Personalizza l’aspetto delle celle e le regole di formattazione condizionale.',
    font: 'Carattere',
    fontDefault: 'Predefinito (tema)',
    fontSize: 'Dimensione',
    textColorLabel: 'Colore testo',
    bgColorLabel: 'Colore sfondo',
    numberFormat: 'FORMATO NUMERO',
    decimals: 'Decimali',
    decimalsHint: 'vuoto = auto',
    currencySymbol: 'Simbolo valuta',
    currencyPlaceholder: '€',
    thousandsSeparator: 'Separatore migliaia',
    thousandSeparator: 'Separatore migliaia',
    decimalSeparator: 'Separatore decimali',
    numberOfDecimals: 'Numero di decimali',
    currencyOther: 'Simbolo',
    currencyAlignment: 'Allineamento valuta',
    nullValue: 'Valore nullo',
    percentage: 'Formatta come percentuale',
    system: 'Sistema',
    none: 'Nessuno',
    other: 'Altro',
    default: 'Predefinito',
    left: 'Sinistra',
    right: 'Destra',
    totalsPosition: 'POSIZIONE TOTALI',
    totalsPositionDesc:
      'Definisce se i subtotali e i totali complessivi vengono visualizzati prima o dopo i dati aggregati.',
    totalsPerRow: 'Totali per riga',
    totalsPerColumn: 'Totali per colonna',
    beforeData: 'Prima dei dati',
    afterData: 'Dopo i dati',
    noTotals: 'Nessuno',
    readability: 'LEGGIBILITÀ',
    alternateRows: 'Righe alternate (effetto zebra per facilitare la lettura)',
    density: 'DENSITÀ',
    densityStandard: 'Normale',
    densityCompact: 'Compatto',
    densityComfortable: 'Spazioso',
    operators: {
      gt: 'Maggiore di (>)',
      gte: 'Maggiore o uguale (≥)',
      lt: 'Minore di (<)',
      lte: 'Minore o uguale (≤)',
      eq: 'Uguale (=)',
      neq: 'Diverso da (≠)',
      between: 'Compreso tra',
    },
    rule: 'Regola',
    rulesDesc: 'Trascina per riordinare le regole.',
    conditionalModeLabel: 'Modalità di valutazione',
    conditionalModeInherit: 'Eredita',
    conditionalModeFirst: 'Ferma alla prima regola soddisfatta',
    conditionalModeAll: 'Valuta tutte le regole',
    conditionalModeFirstDesc:
      "Le regole vengono valutate dall'alto verso il basso; viene applicata la prima che soddisfa la condizione.",
    conditionalModeAllDesc:
      "Le regole vengono valutate dall'alto verso il basso; ogni regola soddisfatta viene applicata — le regole successive sovrascrivono le precedenti per le proprietà che impostano.",
    allMeasures: 'Tutte le misure',
    ruleValue: 'Valore',
    ruleValueAnd: 'e',
    ruleTextColor: 'Testo',
    ruleBgColor: 'Sfondo',
    preview: 'anteprima',
    addRule: 'Aggiungi regola',
    noRules: 'Nessuna regola definita.',
    tabs: {
      headers: 'Intestazioni',
      grandTotals: 'Totali generali',
      dimensions: 'Campi riga/colonna',
      layout: 'Layout',
      values: 'Campi valori',
      conditional: 'Condizionale',
    },
    valuesTarget: 'Applica a',
    valuesDefault: 'Predefinito (tutte le misure)',
    clearOverride: 'Usa predefinito',
    clauseMany: 'clausole',
    clauseOne: 'clausola',
    noClauses: 'nessuna clausola',
    ruleValueAnd: 'e',
    ruleValueConstant: 'Costante',
    ruleValueMeasure: 'Misura',
    selectMeasure: 'Seleziona misura',
    ruleValueUpperBound: 'Upper bound',
    conditionalModeLabel: 'Evaluation mode',
    preview: 'preview',
    expression: 'Espressione',
    addClause: 'Aggiungi clausola',
    expressionJoin: 'Combina le espressioni con',
    editExpression: 'Modifica espressione',
    expressionSubtitle:
      "Combina clausole relative a dimensioni e misure. L'espressione viene valutata cella per cella; la regola si attiva quando restituisce true.",
    value: 'Valore',
    exprAnd: 'E',
    exprOr: 'OPPURE',
    exprStartsWith: 'Inizia con',
    exprEndsWith: 'Termina con',
    exprContains: 'Contiene',
    exprEquals: 'Eguale a',
    exprNot: 'NON',
  },
  dates: {
    monthNames: [
      'Gennaio',
      'Febbraio',
      'Marzo',
      'Aprile',
      'Maggio',
      'Giugno',
      'Luglio',
      'Agosto',
      'Settembre',
      'Ottobre',
      'Novembre',
      'Dicembre',
    ],
    weekdayNames: [
      'Domenica',
      'Lunedì',
      'Martedì',
      'Mercoledì',
      'Giovedì',
      'Venerdì',
      'Sabato',
    ],
    hierarchyParts: {
      year: 'Anno',
      quarter: 'Trimestre',
      month: 'Mese',
      week: 'Settimana',
      day: 'Giorno',
      weekday: 'Giorno della settimana',
      hour: 'Ora',
      minute: 'Minuto',
    },
    quarterLabel: 'Trimestre',
    quarterShortPrefix: 'T',
    weekLabel: 'Settimana',
  },
};

export default it;

export const mergeLocalization = (base, override) => {
  if (!override) return base;
  const out = { ...base };
  Object.keys(override).forEach((section) => {
    out[section] = { ...(base[section] || {}), ...override[section] };
  });
  return out;
};
